import React from 'react';
import { motion } from 'framer-motion';
import { RiMailSendLine, RiMapPin2Line, RiPhoneLine,   RiInstagramLine, RiTwitterLine, RiLinkedinLine } from 'react-icons/ri';
import Footer from '../components/Footer';

const Contact = () => {
    return (
        <div className="bg-white pt-32 min-h-screen">
            <div className="container mx-auto px-6 max-w-7xl pb-32">
                {/* Header Section */}
                <div className="text-center mb-20">
                    <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="text-[10px] font-black text-emerald-600 uppercase tracking-[0.4em] mb-4 block"
                    >
                        Get In Touch
                    </motion.span>
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-4xl md:text-6xl font-bold text-slate-900 font-display"
                    >
                        Join the <span className="text-emerald-600 italic">Conversation.</span>
                    </motion.h1>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
                    {/* Contact Info */}
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        className="lg:col-span-5 space-y-12"
                    >
                        <div>
                            <h2 className="text-3xl font-bold text-slate-900 mb-6 font-display">Communication Hub</h2>
                            <p className="text-slate-500 leading-relaxed max-w-sm">
                                Whether you're a fellow researcher, a prospective partner, or a nature enthusiast, our team is ready to connect.
                            </p>
                        </div>

                        <div className="space-y-8">
                            <div className="flex gap-6 items-start">
                                <div className="w-12 h-12 rounded-2xl bg-emerald-50 flex items-center justify-center text-emerald-600 flex-shrink-0">
                                    <RiMailSendLine size={24} />
                                </div>
                                <div>
                                    <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1">Email Us</span>
                                    <span className="text-lg font-bold text-slate-900">legacy@coe-conservation.org</span>
                                </div>
                            </div>
                            <div className="flex gap-6 items-start">
                                <div className="w-12 h-12 rounded-2xl bg-emerald-50 flex items-center justify-center text-emerald-600 flex-shrink-0">
                                    <RiMapPin2Line size={24} />
                                </div>
                                <div>
                                    <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1">Global HQ</span>
                                    <span className="text-lg font-bold text-slate-900">12 Science Park, Geneva, Switzerland</span>
                                </div>
                            </div>
                            <div className="flex gap-6 items-start">
                                <div className="w-12 h-12 rounded-2xl bg-emerald-50 flex items-center justify-center text-emerald-600 flex-shrink-0">
                                    <RiPhoneLine size={24} />
                                </div>
                                <div>
                                    <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1">Phone</span>
                                    <span className="text-lg font-bold text-slate-900">+41 (0) 22 767 61 11</span>
                                </div>
                            </div>
                        </div>

                        <div className="pt-10 flex gap-4">
                            {[RiInstagramLine, RiTwitterLine, RiLinkedinLine].map((Icon, i) => (
                                <button key={i} className="w-10 h-10 rounded-full border border-slate-100 flex items-center justify-center text-slate-400 hover:bg-slate-900 hover:text-white transition-all">
                                    <Icon size={18} />
                                </button>
                            ))}
                        </div>
                    </motion.div>

                    {/* Contact Form */}
                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        animate={{ opacity: 1, x: 0 }}
                        className="lg:col-span-7"
                    >
                        <div className="bg-slate-50 p-8 md:p-12 rounded-[48px] border border-white">
                            <form className="space-y-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 font-sans">
                                    <div className="space-y-2">
                                        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Full Name</label>
                                        <input type="text" className="w-full bg-white border-slate-100 rounded-2xl h-14 px-6 text-sm font-bold focus:ring-4 focus:ring-emerald-500/10 transition-all border-none" placeholder="John Doe" />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Email Address</label>
                                        <input type="email" className="w-full bg-white border-slate-100 rounded-2xl h-14 px-6 text-sm font-bold focus:ring-4 focus:ring-emerald-500/10 transition-all border-none" placeholder="john@example.com" />
                                    </div>
                                </div>
                                <div className="space-y-2 font-sans">
                                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Inquiry Type</label>
                                    <select className="w-full bg-white border-slate-100 rounded-2xl h-14 px-6 text-sm font-bold focus:ring-4 focus:ring-emerald-500/10 transition-all border-none">
                                        <option>Partnership Inquiry</option>
                                        <option>Research Collaboration</option>
                                        <option>Travel & Expeditions</option>
                                        <option>General Support</option>
                                    </select>
                                </div>
                                <div className="space-y-2 font-sans">
                                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Your Message</label>
                                    <textarea rows="6" className="w-full bg-white border-slate-100 rounded-2xl p-6 text-sm font-bold focus:ring-4 focus:ring-emerald-500/10 transition-all border-none" placeholder="How can we help save the world together?"></textarea>
                                </div>
                                <button className="w-full py-5 bg-slate-900 text-white rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-emerald-600 transition-all shadow-xl font-display">
                                    Send Transmission
                                </button>
                            </form>
                        </div>
                    </motion.div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Contact;
